import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class Faq {
  constructor (el) {
    this.el = el
    this.items = this.el.querySelectorAll('.js-faq-item')
    this.content = '.js-faq-content'
    this.contentWrapper = '.js-faq-content-wrapper'
  }

  init () {
    this.initEvents()
    this.initInitialState()
  }

  initEvents () {
    this.items.forEach(el => {
      el.addEventListener('click', e => this.toggle(e))
    })
  }

  initInitialState () {
    $(this.items).each((i, el) => {
      const $content = $(el).find(this.content)
      $(el).hasClass('active') ? $content.css({ 'display': 'block' }) : $content.css({ 'display': 'none' })
    })
  }

  toggle (e) {
    e.preventDefault()
    const $item = $(e.currentTarget)
    const $content = $item.find(this.content)
    const $contentWrapper = $item.find(this.contentWrapper)

    if ($item.hasClass('active')) {
      $item.removeClass('active')
      $content.slideUp(300).promise().done( function () {
        $(this).css({ 'display': 'none' })
        ScrollTrigger.refresh()
      } )
    } else {
      $(this.items).removeClass('active')
      $(this.content).slideUp(300).promise().done( function () {
        $(this).css({ 'display': 'none' })
        ScrollTrigger.refresh()
      } )
      $item.addClass('active')

      gsap.set($contentWrapper,
        {
          opacity: 0,
          y: 10
        }
      )

      $content.slideDown(300).promise().done( function () {
        $(this).css({ 'display': 'block' })

        gsap.to($contentWrapper,
          {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: 'ease'
          }
        )

      } )
    }
  }
}
